// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c7f37787","404":"0d847a12","787":"f5a752f8"}[chunkId] + ".chunk.js";
};